module.exports = __webpack_public_path__ + "static/media/ch.e3f4cefa.svg";